"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NonOkResponseGraphqlError = void 0;
var _axios = require("@ori/axios");
var _GraphqlError = require("./GraphqlError");
/**
 * Error that indicates that fetch to graphql server was returned with status code that
 * it is not 200, but also lower than 500 HTTP status code
 */
class NonOkResponseGraphqlError extends _GraphqlError.GraphqlError {
  constructor(response) {
    const message = 'Non OK response returned from GraphQl server';
    // eslint-disable-next-line unicorn/custom-error-definition -- okay in this case
    super(new _axios.AxiosError(message, _axios.AxiosError.ERR_BAD_RESPONSE, response.config, response.request, response));
    this.name = 'NonOkResponseGraphqlError';
    this.message = message;
  }
}
exports.NonOkResponseGraphqlError = NonOkResponseGraphqlError;
//# sourceMappingURL=NonOkResponseGraphqlError.js.map